import { DeliveryTypes } from "@utils/enums";

import { StoreDetailsModel } from "@redux/modules/api/data/stores/@types/storeDetails.model";

export const $ProductDetailModuleName = "productDetail";

export type TProductDetailState = {
    deliveryType: DeliveryTypes;
    shop: StoreDetailsModel | null;
    quantity: number;
    sku: string;
    stickyOrderButton: boolean;
    serviceProductSkus: string[];
};
